import { render, staticRenderFns } from "./TourView.vue?vue&type=template&id=958c3008"
import script from "./TourView.vue?vue&type=script&lang=js"
export * from "./TourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports